import * as React from "react"
import { Box } from "@mui/material";

import {DateRangeBlock} from "@components";
import {DATE_PERIODS} from "@constants";
import {rangeDatesPricingChanges} from "./Ranges";
import {pricingChangesEvolutionCurrentPeriod} from "../@signals";


export default function PriceChangesPriceEvolutionChartToolbar({dateRange, onChangeDate}) {

    return <Box sx={{ display: 'flex', gap: 2, alignItems: 'center'}}>
        <DateRangeBlock
            currentPeriodLabel={pricingChangesEvolutionCurrentPeriod.value}
            maxDays={30}
            value={dateRange}
            ranges={rangeDatesPricingChanges}
            onChange={onChangeDate}
            onOk = { () => pricingChangesEvolutionCurrentPeriod.value = DATE_PERIODS.CUSTOM }
        />
    </Box>
}


